function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var _require = require('./burn-fee-timing'),
  getHeartbeatMs = _require.getHeartbeatMs;
var _require2 = require('./golden-ticket-mining'),
  mineAndSubmitOneGoldenTicket = _require2.mineAndSubmitOneGoldenTicket;
var _require3 = require('./manual-block-produce-wait'),
  waitForManualBlockProduction = _require3.waitForManualBlockProduction;
var _require4 = require('./verify-golden-ticket-block'),
  getBlockHashAtHeight = _require4.getBlockHashAtHeight,
  snapshotMempoolFeeTransactionSignatures = _require4.snapshotMempoolFeeTransactionSignatures,
  verifyProducedGoldenTicketBlock = _require4.verifyProducedGoldenTicketBlock;
var _require5 = require('./manual-production-log'),
  logManualProduction = _require5.logManualProduction,
  logManualProductionError = _require5.logManualProductionError;

/**
 * Mine one GT, wait for burn-fee timing, call wallet.produceBlockWithGt(), and
 * verify the resulting block contains that GT plus any waiting fee transactions.
 */
function produceExplorerBlockWithGt(_x, _x2, _x3) {
  return _produceExplorerBlockWithGt.apply(this, arguments);
}
function _produceExplorerBlockWithGt() {
  _produceExplorerBlockWithGt = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, mod, startBlockId) {
    var startId, heartbeatMs, miningDeadline, feeTransactions, _gtTx, previousBlockHash, feeTxSignaturesBefore, gtTx, produced, verified, _t2, _t3;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.p = _context2.n) {
        case 0:
          startId = Number(startBlockId) || 0;
          heartbeatMs = getHeartbeatMs(app);
          miningDeadline = Date.now() + Math.max(heartbeatMs * 8, 600000);
          feeTransactions = Array.isArray(mod === null || mod === void 0 ? void 0 : mod.pendingManualProduceTransactions) ? _toConsumableArray(mod.pendingManualProduceTransactions) : [];
          logManualProduction("produceExplorerBlockWithGt() entered (startBlockId=".concat(startId, ")"));
          _context2.p = 1;
          _context2.n = 2;
          return getBlockHashAtHeight(app, startId);
        case 2:
          previousBlockHash = _context2.v;
          _context2.n = 3;
          return snapshotMempoolFeeTransactionSignatures(app);
        case 3:
          feeTxSignaturesBefore = _context2.v;
          logManualProduction("GT production prep: previousBlockHash=".concat(previousBlockHash || '(unknown)', ", ") + "feeTxsWaiting=".concat(feeTxSignaturesBefore.length));
          logManualProduction('Mining started');
          _context2.p = 4;
          _context2.n = 5;
          return mineAndSubmitOneGoldenTicket(app, miningDeadline);
        case 5:
          gtTx = _context2.v;
          _context2.n = 7;
          break;
        case 6:
          _context2.p = 6;
          _t2 = _context2.v;
          logManualProductionError('mineAndSubmitOneGoldenTicket', _t2);
          throw _t2;
        case 7:
          logManualProduction("Mining completed; GT submitted (signature=".concat((_gtTx = gtTx) !== null && _gtTx !== void 0 && _gtTx.signature ? String(gtTx.signature).slice(0, 16) + '...' : '(none)', ")"));
          logManualProduction('Entering production loop (wallet.produceBlockWithGt)');
          _context2.n = 8;
          return waitForManualBlockProduction(app, startId, /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
            var result, _t;
            return _regenerator().w(function (_context) {
              while (1) switch (_context.p = _context.n) {
                case 0:
                  logManualProduction('Calling wallet.produceBlockWithGt()');
                  result = false;
                  _context.p = 1;
                  _context.n = 2;
                  return app.wallet.produceBlockWithGt(feeTransactions.length ? feeTransactions : undefined);
                case 2:
                  result = _context.v;
                  _context.n = 4;
                  break;
                case 3:
                  _context.p = 3;
                  _t = _context.v;
                  logManualProductionError('wallet.produceBlockWithGt', _t);
                  throw _t;
                case 4:
                  logManualProduction("wallet.produceBlockWithGt() returned: ".concat(result));
                  return _context.a(2, result);
              }
            }, _callee, null, [[1, 3]]);
          })), {
            heartbeatMs: heartbeatMs
          });
        case 8:
          produced = _context2.v;
          if (produced) {
            _context2.n = 9;
            break;
          }
          logManualProduction('GT production loop finished without new block');
          return _context2.a(2, {
            blockProduced: false
          });
        case 9:
          if (feeTransactions.length) {
            mod.pendingManualProduceTransactions = [];
          }
          logManualProduction('Verifying produced GT block');
          _context2.n = 10;
          return verifyProducedGoldenTicketBlock(app, startId, previousBlockHash, feeTxSignaturesBefore);
        case 10:
          verified = _context2.v;
          logManualProduction("GT block verification: ".concat(verified ? 'passed' : 'failed'));
          return _context2.a(2, {
            blockProduced: true,
            verificationPassed: verified,
            verificationWarning: verified ? undefined : 'Explorer GT verification failed.'
          });
        case 11:
          _context2.p = 11;
          _t3 = _context2.v;
          logManualProductionError('produceExplorerBlockWithGt', _t3);
          throw _t3;
        case 12:
          return _context2.a(2);
      }
    }, _callee2, null, [[4, 6], [1, 11]]);
  }));
  return _produceExplorerBlockWithGt.apply(this, arguments);
}
module.exports = {
  produceExplorerBlockWithGt: produceExplorerBlockWithGt
};